import { UserManager, WebStorageStateStore } from "oidc-client-ts";

export const userManager = new UserManager({
  scope: process.env.REACT_APP_OIDC_SCOPE,
  silent_redirect_uri: window.location.origin,
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  response_type: process.env.REACT_APP_RESPONSE_TYPE,
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,

  // automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: localStorage }),
});
